import { DetailAction } from '../../detail/actions/DetailAction';
import { FilterState, listFilterType } from '../../../pages/content/listPage/FilterState';
import { Backend } from '../../../api/Backend';
import { OptionData } from '../../../components/option/OptionData';
import { AccessibilityTypes } from '../../AccessibilityTypes';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';

export class ListAccessibilityFilterActionHandler extends DetailAction {
  constructor(backend: Backend, private filterState: FilterState) {
    super(backend);
  }

  override doAction() {
    const selected = this.filterState.stateOf(listFilterType.accessibility);
    const options = Object.values(AccessibilityTypes)?.map(type => this._optionFromType(type, selected));
    this.owner?.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        backend: this._backend,
        options: options,
        onSuccess: (val: OptionData) => {
          this.optionSelected(val);
        },
        onCancelled: this.hideOptions.bind(this),
      },
    });
  }

  _optionFromType(type: AccessibilityTypes, selected: AccessibilityTypes) {
    const result: OptionData = { options: [], value: undefined };
    result.text = this._backend.translations.forKey(`accessibility_${type.toLowerCase()}`);
    result.selected = selected && selected === type;
    result.value = type;
    return result;
  }

  optionSelected(option: OptionData) {
    this.filterState.updateState(listFilterType.accessibility, option.text, option.value);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }
}
